import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'

import { ReactComponent as EditSvg } from '../../assets/edit.svg'
import { ReactComponent as DeleteSvg } from '../../assets/delete.svg'
import { ReactComponent as CloseSvg } from '../../assets/ExitDelete.svg'
import MaisConteudoAPi from '../../services/MaisConteudoAPi'
import SendGTAGEvent from '../../utils/sendGTAGEvent'

import * as S from './styles'
import ModalBackdrop from '../ModalBackdrop'
import useWishList from '../../hooks/WishListContext'
import { useNavigate, useParams } from 'react-router-dom'

interface IFormValuesState {
  name: string;
  brand: string;
  description: string;
  link: string;
  code: string;
  products: { productRef: string; }[]
}

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  buttonLabel?: string;
  onClickEditButton: () => void;
  onClickDeleteButton: () => void;
  buttonText?: string;
  buttonIcon?: React.RefObject<HTMLInputElement>;
}

const EditWishlistModal: React.FC<ModalProps> = ({
  isOpen,
  onClickEditButton,
  onClickDeleteButton,
  onClose,
}) => {

  const { onOpenWishListHandler, setOpenedWishList } = useWishList()
  const mounted = useRef(false);

  const { linkId } = useParams()
  const navigate = useNavigate()

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const [formValues, setFormValues] = useState<IFormValuesState>({
    brand: '',
    description: '',
    name: '',
    code: '',
    link: '',
    products: []
  })


  const ParamsInsertMemo = useMemo(() => (
    formValues.link.length > 0 ?
      {
        name: formValues.name,
        description: formValues.description,
        linkName: formValues.link
      }
      :
      {
        name: formValues.name,
        description: formValues.description,
      }

  ), [formValues.description, formValues.link, formValues.name])


  const onFetchWishlistHandler = useCallback(async () => {
    try {
      const res = await MaisConteudoAPi.get(`/v1/wishlists/${linkId}`)

      if (mounted.current) {
        setFormValues({
          brand: res.data.environment,
          description: res.data.description,
          name: res.data.name,
          code: res.data.code,
          link: res.data.linkName || '',
          products: res.data.products
        })
      }

    } catch (error: any) {
      console.log(error.response?.data.message)
    }
  }, [linkId])

  const onSubmitFormHandler = useCallback(async () => {

    try {
      const res = await MaisConteudoAPi.patch(`/v1/wishlists/${linkId}`, ParamsInsertMemo)
      setOpenedWishList({
        action: 'edit',
        linkId: linkId || res.data.linkId,
        linkName: formValues.link || '',
        code: formValues.code,
        vtexBrandName: formValues.brand,
        name: formValues.name,
        description: formValues.description,
        products: formValues.products
      })

      onOpenWishListHandler()
      navigate('/produtcs')

    } catch (error: any) {
      console.log(error.response?.data.message)
    }

  }, [ParamsInsertMemo, formValues.brand, formValues.code, formValues.description, formValues.link, formValues.name, formValues.products, linkId, navigate, onOpenWishListHandler, setOpenedWishList])

  useEffect(() => {
    mounted.current = true
    onFetchWishlistHandler()
    return () => { mounted.current = false }
  }, [onFetchWishlistHandler])

  const OptionsWishlist = useMemo(() => {
    return (
      <S.Container className={`${!isOpen ? 'hidden' : ''}`}>
        <div className='close'>
          <CloseSvg onClick={onClose} />
        </div>

        <S.WishlistInformationsSettings>
          <button className='btn__products' onClick={() => {
            onSubmitFormHandler()
            SendGTAGEvent(
              'editar_produtos',
              'Lojinha',
              'Clicou em botão "Editar produtos',
              formValues.brand
            )
          }} >
            <EditSvg />
            editar produtos
          </button>
          <button className='btn__edit' onClick={() => {
            onClickEditButton()
            SendGTAGEvent(
              'editar_informacoes',
              'Lojinha',
              'Clicou em botão "Editar informações',
              formValues.brand
            )
          }}>
            <EditSvg />
            editar informações
          </button>
          <button className='btn__delete' onClick={() => {
            onClickDeleteButton()
            SendGTAGEvent(
              'excluir_lojinha',
              'Lojinha',
              'Clicou em botão "Excluir lojinha',
              formValues.brand
            )
          }} >
            <DeleteSvg />
            excluir lojinha
          </button>
        </S.WishlistInformationsSettings>

      </S.Container>
    )
  }, [formValues.brand, isOpen, onClickDeleteButton, onClickEditButton, onClose, onSubmitFormHandler])

  useEffect(() => {
    function handleResize() {
      setIsSmallScreen(window.innerWidth < 768);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    !isSmallScreen ?
      OptionsWishlist :
      isOpen ? (
        <ModalBackdrop isOpen={isOpen} onClose={onClose} >
          {OptionsWishlist}
        </ModalBackdrop>) : null
  )
}

export default EditWishlistModal